import { GlobalEnumsAceBenutzerrolle } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-benutzerrolle";

export class UserModel {
    public get fullname(): string {
        return this.firstname + " " + this.lastname;
    } 
    public firstname: string;
    public lastname: string;
    public username: string;
    public benutzerrolle: GlobalEnumsAceBenutzerrolle;
}

